"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/*
 * FROM: https://github.com/react-bootstrap/react-overlays/blob/master/src/utils/addEventListener.js
 */
const addEventListener_1 = tslib_1.__importDefault(require("dom-helpers/addEventListener"));
const removeEventListener_1 = tslib_1.__importDefault(require("dom-helpers/removeEventListener"));
function default_1(node, event, handler, capture) {
    (0, addEventListener_1.default)(node, event, handler, capture);
    return {
        remove() {
            (0, removeEventListener_1.default)(node, event, handler, capture);
        },
    };
}
exports.default = default_1;
